import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from '@env';

import {
  AcquisitionEventsResponse,
  AcquisitionProvidersResponse,
  BleikPullSettings,
  BleikPullSettingsView,
  GetAcquisitionEventsParams,
} from '../../../interfaces/acquisition.interface';
import { AcquisitionApiService } from './acquisition-api.service';

/** Cliente de la API de adquisición. Los filtros viajan como `filter[x]`; `page` y `perPage` aparte. */
@Injectable()
export class AcquisitionHttpService extends AcquisitionApiService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = `${environment.salesApiGateway}acquisition`;

  listProviders(): Observable<AcquisitionProvidersResponse> {
    return this.http.get<AcquisitionProvidersResponse>(`${this.baseUrl}/providers`);
  }

  refreshCustomFields(code: string): Observable<{ provider: string }> {
    return this.http.post<{ provider: string }>(
      `${this.baseUrl}/providers/${encodeURIComponent(code)}/custom-fields/refresh`,
      {},
    );
  }

  listEvents(params: GetAcquisitionEventsParams): Observable<AcquisitionEventsResponse> {
    const { page, perPage, ...filters } = params;
    let httpParams = new HttpParams();
    for (const [key, value] of Object.entries(filters)) {
      if (value !== undefined && value !== '') {
        httpParams = httpParams.set(`filter[${key}]`, value);
      }
    }
    if (page) {
      httpParams = httpParams.set('page', page);
    }
    if (perPage) {
      httpParams = httpParams.set('perPage', perPage);
    }
    return this.http.get<AcquisitionEventsResponse>(`${this.baseUrl}/events`, {
      params: httpParams,
    });
  }

  getBleikSettings(): Observable<BleikPullSettingsView> {
    return this.http.get<BleikPullSettingsView>(`${this.baseUrl}/bleik/settings`);
  }

  updateBleikSettings(settings: BleikPullSettings): Observable<{ settings: BleikPullSettings }> {
    return this.http.put<{ settings: BleikPullSettings }>(
      `${this.baseUrl}/bleik/settings`,
      settings,
    );
  }
}
